import { all, call, delay, put, takeLatest } from 'redux-saga/effects'

import { push } from '@lagunovsky/redux-react-router'
import { PATH_NAME } from 'app/constants'
import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { requireCinemaId } from 'components/Modal/CinemaSelectWindow/saga'
import { setErrorMessage, setSuccessMessage } from 'components/Windows/CentralMessagesList/reducer'
import { callApiAsync } from 'services/api/callAPIAsync'
import { getData } from '../../Basket/reducer'
import { registerClub } from './reducer'

function* registerClubCallSaga(action) {
    const cinemaid = yield call(requireCinemaId)
    if (!cinemaid) return
    const gender = action?.payload?.gender
    const birthdate = new Date(action?.payload?.date).toISOString()
    const city = action?.payload?.residance
    const zip_code = action?.payload?.postalCode.toString()
    const mail_sending = action?.payload?.checkBox
    yield put(startLoading())
    const { error } = yield call(callApiAsync, 'loyaltyProgramRegister', {
        cinemaid,
        gender,
        birthdate,
        city,
        zip_code,
        mail_sending,
    })
    yield put(stopLoading())
    if (error && error !== 'E_API_CARD_ALREADY_IN_CART') {
        yield put(setErrorMessage(error))
        console.error(error)
        return
    }
    yield put(getData())
    yield put(push(PATH_NAME.ORDER_SUMMARY))
    yield delay(10)
    yield put(setSuccessMessage('REGISTER_CLUB_SUCCESS'))
}

export default function* registerClubSaga() {
    yield all([takeLatest(registerClub.type, registerClubCallSaga)])
}
